export const isEven = num => {
	return num % 2 === 0 ? true : false;
};
